import $ from 'jquery';
// Collection of functions for use by all modules

// Globals 
var xDown = null; // x coordinate for touches
var yDown = null; // y coordinate for touches
var screenSize; // 0:sm, 1:md, 2:lg

export function getScreenSize() {
    if ($(window).outerWidth() < 768) {
        screenSize = 0;
    } else if ($(window).outerWidth() < 1024) {
        screenSize = 1;
    } else {
        screenSize = 2;
    }
    return screenSize;
}

export function cookieConsent() {
    $(".cookie-banner").fadeOut(500);
    document.cookie = "cookieConsent=1; max-age=31536000; path=/; samesite=lax; Secure;"
}

/**
 * Function to follow external links including a warning to the user
 * @param e click event
 */
function followExtLink(e) {
    var url = $(e.delegateTarget).attr("href");
    //ToDo: Show warning about leaving the site
    if (url != undefined)
        followLink(url, true);
}

function followLink(url, blank) {
    blank ? window.open(url) : window.open(url, "_self");
}

function handleTouchStart(e) {
    xDown = e.originalEvent.touches[0].clientX;
    yDown = e.originalEvent.touches[0].clientY;
}

function handleTouchMove(e) {
    if (!xDown || !yDown)
        return;

    var xUp = e.originalEvent.changedTouches[0].clientX;
    var yUp = e.originalEvent.changedTouches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
        if (xDiff > 0) {
            // right swipe
            return -1;
        } else {
            // left swipe
            return 1;
        }
    } else {
        if (yDiff > 0) {
            // down swipe
            return -2;
        } else {
            // up swipe
            return 2;
        }
    }
}

function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

function toggleCollapse(element) {
    $(element).toggleClass("collapsed");
    $(element).next().slideToggle();
}

function closeAlert() {
    $(".alert").fadeOut(250).css("top", "").css("background-color", "");
}

export { followExtLink, followLink, handleTouchStart, handleTouchMove, isTouchDevice, toggleCollapse, closeAlert };